import _ from 'lodash';
import { useCallback, useEffect } from 'react';
import { MessageService } from 'services';
import { ErrorItem } from 'types/error';
import { resetMessage, setNoAccess } from 'app/settings/slices';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { message } from 'antd';

import { selectSuccessMessage, selectErrorMessage } from 'app/settings/selectors';
import { AppConstants } from 'constants/index';

const Notification = () => {
  const dispatch = useAppDispatch();

  const [messageApi, contextHolder] = message.useMessage();
  const successMessage = useAppSelector(selectSuccessMessage);
  const errorMessage = useAppSelector(selectErrorMessage);

  const onClose = useCallback(() => {
    dispatch(resetMessage());
  }, [dispatch]);

  useEffect(() => {
    MessageService.setMessage(messageApi);
  }, [messageApi]);

  useEffect(() => {
    if (successMessage || errorMessage?.errors?.length) {
      if (errorMessage.status && (AppConstants.redirectStatusCodes as readonly number[]).includes(errorMessage.status)) {
        onClose();
        dispatch(setNoAccess(true));
      } else {
        if (_.isArray(errorMessage.errors) && errorMessage.errors.length) {
          errorMessage.errors.map((err: ErrorItem) => MessageService.error({
            content: err.errorMessage,
            onClose,
          }));
        }

        if (successMessage) {
          MessageService.success({
            content: successMessage,
            onClose,
          });
        }
        onClose();
      }
    }
  }, [errorMessage, successMessage, dispatch, onClose]);

  return contextHolder;
};

export default Notification;
